import firebase from '../constants/firebase';

const getContentForFaq = async faqs => {
  return Promise.all(
    faqs.map(async d => {
      return {
        ...d.data(),
        id: d.id,
      };
    })
  );
};

export const get = async faqId => {
  const db = firebase.firestore();

  let querySnapshot = db
    .collection('faq')
    .where('isDeleted', '==', false)
    .where('id', '==', faqId);

  const docs = [...(await querySnapshot.get()).docs];

  return getContentForFaq(docs);
};

const listFaqs = async () => {
  const db = firebase.firestore();

  let docs = [];

  docs = [
    ...(
      await db
        .collection('faq')
        .where('isDeleted', '==', false)
        .get()
    ).docs,
  ];

  return getContentForFaq(docs);
};

export const list = async () => {
  const docs = await listFaqs();

  return Promise.all(docs);
};

export const save = async faq => {
  const db = firebase.firestore();

  // Create or update folder
  const doc = await db.collection('faq').doc(faq.id);

  doc.set(faq);
};
